const REFERRAL_INVITE_CODE_PATTERN = /^cr_[A-Za-z0-9_-]+$/;
const REFERRAL_INVITE_PATH_PATTERN = /^\/invite\/(cr_[A-Za-z0-9_-]+)$/;

export const REFERRAL_ATTRIBUTION_QUERY_PARAM = "referral";
export const REFERRAL_ATTRIBUTION_DISABLED_VALUE = "none";

export const isReferralAttributionDisabled = (value?: string | null): boolean =>
  value === REFERRAL_ATTRIBUTION_DISABLED_VALUE;

export const isReferralInviteCode = (value?: string | null): boolean =>
  Boolean(value && REFERRAL_INVITE_CODE_PATTERN.test(value));

export const isShortReferralInvitePath = (pathname: string): boolean =>
  /^\/cr_[A-Za-z0-9_-]+$/.test(pathname);

export const getReferralInviteCodeFromLegacyPath = (pathname: string): string | null => {
  const match = pathname.match(REFERRAL_INVITE_PATH_PATTERN);
  return match?.[1] || null;
};
